export default {
	clientId: process.env.REACT_APP_RD_STATION_MARKETING_CLIENT_ID
}
